export const Langs = ['ru', 'en', 'pt', 'tr', 'fr', 'es', 'it', 'de', 'ph', 'id']
